import { Injectable } from '@angular/core';
import { GqlServiceV2 } from '../../content/service/gql.service-v2';
import { InboxModuleTypeInput } from '@libs/types/src/inbox/input-type/inbox-module-type.input';
import { InboxUserSettingsObject } from '@libs/types/src/inbox/object-type/inbox-user-settings.object';
import { InboxUserSettingsUpdateInput } from '@libs/types/src/inbox/input-type/inbox-user-settings.update-input';
import { OkObject } from '@it2go/types';

@Injectable({ providedIn: 'root' })
export class InboxUserSettingsGqlService extends GqlServiceV2 {

    async getInboxUserSettings(input: InboxModuleTypeInput, frag: string) {
        return this.query<InboxUserSettingsObject>(
            `
                query($input: InboxModuleTypeInput!) {
                    inboxUserSettings {
                        get(input: $input) {
                            ${frag}
                        }
                    }
                }
            `,
            { input },
        );
    }

    async updateInboxUserSettings(input: InboxUserSettingsUpdateInput): Promise<OkObject> {
        return this.mutate(
            `
                mutation($input: InboxUserSettingsUpdateInput!) {
                    inboxUserSettings {
                        update(input: $input) {
                            ok
                        }
                    }
                }
            `,
            { input },
        );
    }
}
